import React from 'react'
import energyDrink from '../../assets/images/gc-cola.png';
import oliveOil from '../../assets/images/oliveOil.png';
import oil from '../../assets/images/oil.png';
import cola from '../../assets/images/cola.png';

import pineapple from '../../assets/images/pineapple.png';
import peach from '../../assets/images/peach.png';
import apple from '../../assets/images/apple.png';
import lemon from '../../assets/images/lemon.png';
import apricort from '../../assets/images/apricot.png';
import orange from '../../assets/images/orange.png';
import mixFruit from '../../assets/images/mix-fruit.png';



function TextAnimation() {

    const shuffleArray = (array)=> {
        return array.sort(() => Math.random() - 0.5)
    }
    const data = [
        [
            {
                text:`SUN FLOWER OIL`,
                icon:oil
            },
            {
                text:'GC COLA',
                icon:cola
            },
            {
                text:'JUICES',
                icon:orange
            },
            {
                text:'GULF ENERGY DRINK',
                icon:energyDrink
            },
            {
                text:'OLIVE OIL',
                icon:oliveOil
            },
            {
                text:'JUICES',
                icon:apple
            },
        ],
        [
            {
                text:'GULF ENERGY DRINK',
                icon:energyDrink
            },
            {
                text:'JUICES',
                icon:pineapple
            },
            {
                text:'OLIVE OIL',
                icon:oliveOil
            },
            {
                text:'JUICES',
                icon:apricort
            },
            {
                text:'GC COLA',
                icon:cola
            },
            {
                text:'SUN FLOWER OIL',
                icon:oil
            },
            {
                text:'JUICES',
                icon:peach
            },
        ],
        [
            {
                text:'JUICES',
                icon:lemon
            },
            {
                text:'SUN FLOWER OIL',
                icon:oil
            },
            {
                text:'OLIVE OIL',
                icon:oliveOil
            },
            {
                text:'JUICES',
                icon:mixFruit
            },
            {
                text:'GULF ENERGY DRINK',
                icon:energyDrink
            },
            {
                text:'GC COLA',
                icon:cola
            },
        ]
    ];
    return (
        <div className="animation-container">
            {
                data.map((items,index)=>(
                    <div className={index==1?'right-to-left':'left-to-right'}>
                        <div class="text-box">
                            {
                                items.map((item)=>(
                                    <div className='text' >
                                        <div className='position-relative'>
                                            <h1>{ item.text }</h1>
                                            <img src={item.icon} alt='' />
                                        </div>
                                        <h1>.</h1>
                                    </div>

                                ))
                            }
                        </div>
                        <div class="text-box">
                            {
                                items.map((item)=>(
                                    <div className='text' >
                                        <div className='position-relative'>
                                            <h1>{ item.text }</h1>
                                            <img src={item.icon} alt='' />
                                        </div>
                                        <h1>.</h1>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                ))
            }
                    
        </div>
    )
}

export default TextAnimation